import axios from 'axios'
import Qs from 'qs'
import vue from '@/main.js'
import api from "@/api";
import store from '@/store/index'
let issub = false
// 定时器全局变量
let messageCount = null

function get(url, data) {
	return api.get(url, data);
}

function post(url, data) {
	return api.post(url, data)
}


let upload = function(url, param, callback, errcallback) {
    axios({
        url: process.env.VUE_APP_API_ROOT + url,
        // https://ncv.czhic.cn/h5/gettoken.html
        // 对封装好的对象进行序列化,如果后台没说明可以直接传obj对象就行
        data: param,
        // 定义get请求或者post请求
        method: 'post',
        // 设置参数的表头形式，这是表单形式传递
        headers: {
            'Authorization': 'Bearer ' + store.state.token
        }
        // 对data的参数转化为键值对
        // transformRequest: [function(data) {
        //     data = Qs.stringify(data)
        //     return data
        // }]
    }).then(res => {
        // 后台成功请求200运行到这里
        if (callback) {
            callback(res.data)
			console.log(res.data)
        }

    }).catch(err => {
		if (errcallback) {
		    errcallback(err)
		}
        console.log('访问不到', err)
        valert('网络或服务器繁忙，请稍后再试')
    })
}


let vmsg = function(t,type) {
	vue.$message({
	    showClose: true,
	    message: t,
	    type: type || 'success',
	});
}

let valert = function(txt, callback) {
	vue.$alert(txt, '提示', {
		confirmButtonText: '确定',
		customClass:"confirm",
		callback: () => {
			if (callback) {
				callback()
			}
		}
	})
}

let vconfirm = function(txt, callback1, callback2) {
	vue.$confirm(txt, '提示', {
		confirmButtonText: '确定',
		cancelButtonText: '取消',
		type: 'warning',
		customClass:"confirm"
	}).then(() => {
		if (callback1) {
			callback1()
		}
	}).catch(() => {
		if (callback2) {
			callback2()
		}
	})
}

let tourl = function(path, param) {
	const currentPath = vue.$route.path
	if (currentPath == path) {
		return
	}
	if (!param) {
		param = {}
	}
	// param.curtime = new Date().getTime()
	vue.$router.push({
		path: path,
		query: param
	})
}
let tourlByname = function(name, param) {
	if (!param) {
		param = {}
	}
	vue.$router.push({
		name: name,
		query: param
	})
}
let torurl = function(path, param) {
	if (!param) {
		param = {}
	}
	vue.$router.replace({
		path: path,
		query: param
	})
}
let tourl_blank = function(path, param) {
	if (!param) {
		param = {}
	}
	const routeUrl = vue.$router.resolve({
		path,
		query: param
	});
	console.log(routeUrl)
	window.open(routeUrl.href, "_blank");
}


let torurlByname = function(name, param) {
	if (!param) {
		param = {}
	}
	vue.$router.replace({
		name: name,
		query: param
	})
}
let toback = function() {
	vue.$router.go(-1)
}

let getUrlParam = function(name) {
	if (name) {
		var p = vue.$route.query[name]
		return p
	} else {
		return ''
	}

}

let loading = function(tf) {
	// 显示
	const loading = vue.$loading({
		lock: true,
		text: '加载中'
		// spinner: 'el-icon-loading',
		// background: 'rgba(0, 0, 0, 0.7)'
	})

	if (tf == 'false') {
		loading.close()
	}
}

// 判断是否正确输入手机号码或电话号码,正确为true
let checkPhone = function(phone) {
	var regBox = {
		regMobile: /^1[0123456789]\d{9}$/, // 手机
		regTel: /^0[\d]{2,3}[\d]{8,9}$/
	}
	var mflag = regBox.regMobile.test(phone)
	var tflag = regBox.regTel.test(phone)
	if (mflag || tflag) {
		return true
	} else {
		return false
	}
}
// 判断输入是否为空，空为true
let chkblk = function(ele) {
	if (ele.replace(/(^\s*)|(\s*$)/g, '') == '')
		return true
}
// 验证车牌号码
let check_cphm = function(licensePlate) {
	console.info('进入到车牌校验')
	var re = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/
	if (licensePlate.search(re) == -1) {
		return false
	} else {
		return true
	}
}
// 判断身份证号码是否正确，正确为true
var chksfz = function(num) {
	num = num.toUpperCase();
	//身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。   
	if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num))) {
		return false;
	}
	//校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。 
	//下面分别分析出生日期和校验位 
	var len, re;
	len = num.length;
	if (len == 15) {
		re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
		var arrSplit = num.match(re);

		//检查生日日期是否正确 
		var dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
		var bCorrectDay;
		bCorrectDay = (dtmBirth.getYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[
				3])) &&
			(
				dtmBirth.getDate() == Number(arrSplit[4]));
		if (!bCorrectDay) {
			return false;
		} else {
			//将15位身份证转成18位 
			//校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。 
			var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
			var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
			var nTemp = 0,
				i;
			num = num.substr(0, 6) + '19' + num.substr(6, num.length - 6);
			for (i = 0; i < 17; i++) {
				nTemp += num.substr(i, 1) * arrInt[i];
			}
			num += arrCh[nTemp % 11];
			return true;
		}
	}
	if (len == 18) {
		re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
		var arrSplit = num.match(re);

		//检查生日日期是否正确 
		var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
		var bCorrectDay;
		bCorrectDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(
				arrSplit[3])) &&
			(dtmBirth.getDate() == Number(arrSplit[4]));
		if (!bCorrectDay) {
			return false;
		} else {
			//检验18位身份证的校验码是否正确。 
			//校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。 
			var valnum;
			var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
			var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
			var nTemp = 0,
				i;
			for (i = 0; i < 17; i++) {
				nTemp += num.substr(i, 1) * arrInt[i];
			}
			valnum = arrCh[nTemp % 11];
			if (valnum != num.substr(17, 1)) {
				return false;
			}
			return true;
		}
	}
	return false;
}

let iscode = function(c, msg, fun, fun1) {
	if (c == 1000) {
		if (fun) {
			fun()
		}
	} else {
		console.log(c)
		if (fun1) {
			valert(msg, function() {
				fun1()
			})
		} else {
			valert(msg)
		}

	}
}

let getBase64 = function(file) {
	return new Promise(function(resolve, reject) {
		const reader = new FileReader()
		let imgResult = ''
		reader.readAsDataURL(file)
		reader.onload = function() {
			imgResult = reader.result
		}
		reader.onerror = function(error) {
			reject(error)
		}
		reader.onloadend = function() {
			resolve(imgResult)
		}
	})
}

let merge = function(data, key) {
	const newData = data.map((item, index) => {
		const filterData = data.filter(ele => {
			return item[key] == ele[key]
		})
		const index_ = data.findIndex(ele => {
			return item[key] == ele[key]
		})
		if (index == index_) {
			item.rowspan = filterData.length
		} else {
			item.rowspan = 0
		}
		return item
	})
	return newData
}

//el-table合并同类项 table属性方法
let arraySpanMethod = function({
	row,
	columnIndex
}) {
	if (columnIndex === 0) {
		return {
			rowspan: row.rowspan,
			colspan: 1
		}
	}
}
//三位分节法
let formatNumber = function(num, separator = ',') {
    if (num === null || num === undefined || num === '') return '';

    // 转换为字符串
    let numStr = String(num);

    // 处理负数
    let isNegative = false;
    if (numStr.startsWith('-')) {
        isNegative = true;
        numStr = numStr.substring(1);
    }

    // 分割整数和小数部分
    const parts = numStr.split('.');
    let integerPart = parts[0];
    let decimalPart = parts[1] || '';

    // 格式化整数部分
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, separator);

    // 重新组合
    let result = isNegative ? '-' + integerPart : integerPart;
    if (decimalPart) {
        result += '.' + decimalPart;
    }

    return result;
}
export default {
	formatNumber,//三位分节法
	post, // post提交
	get, // get提交
	upload,//
	vmsg, // 轻提示
	valert, // 弹出确认框
	vconfirm, // 弹出确认取消框
	tourl, // 跳转到路由path,tourl(path,{a:1,b:2...})
	tourl_blank,
	torurl, // 跳转到路由path,并清除当前跳转记录
	tourlByname, // 跳转到路由name,tourl(name,{a:1,b:2...})
	torurlByname, // 跳转到路由name,并清除当前跳转记录
	toback, // 返回上一页
	getUrlParam, // 获取url参数值
	loading, // 加载中
	checkPhone, // 验证手机号码
	chkblk, // 验证是否为空
	check_cphm, // 验证车牌号码
	chksfz, // 验证身份证
	iscode,
	getBase64, // 图片转Base64
	messageCount,
	merge,
	arraySpanMethod
}